import React, {useEffect, useState, useCallback} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faClose
} from "@fortawesome/free-solid-svg-icons";
import Button from "../elements/Button";

const Modal = ({open, title, children, onClose}) => {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="bg-white rounded-lg w-full max-w-2xl p-6 shadow-lg">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <Button onClick={onClose}>
                        <FontAwesomeIcon icon={faClose} size='xl'/>
                    </Button>
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
};

export default Modal;